module.exports = __webpack_public_path__ + "img/figure-5.9ed641b5.png";